<template>
  <div>
    <Navbar/>
    <Aboutus/>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '@/components/homepage/Navbar'
import Aboutus from '@/components/homepage/Aboutus'
import Footer from '@/components/homepage/Footer'
export default {
  components: {
    Navbar,
    Aboutus,
    Footer
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/homepage/Aboutuspage.vue